import styles from "./ArticleUtilityBar.module.scss";

const ArticleUtilityBar = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.root}>{children}</div>;
};

export default ArticleUtilityBar;
